import { useLayoutEffect, useState } from "react";
import api from "../../services/api";
import GeneralContext from "./GeneralContext";
import EModulePermissions from "../../enums/EModulePermissions"
// Mantem uma variável atualizada com as dimensoes da tela
const useWindowSize = () => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight])

  useLayoutEffect(() => {

    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }

    window.addEventListener('resize', updateSize)
    updateSize();
    return () => window.removeEventListener('resize', updateSize)

  }, [])

  return size
}


export default function GeneralContextProvider({ children }) {

  const [windowWidth, windowHeight] = useWindowSize()

  const maxWidthMobileMode = 700 //px
  const mobile_mode = windowWidth <= maxWidthMobileMode

  const [loggedUser, setLoggedUser] = useState(null)
  const [show_loading, setShowLoading] = useState(false)
  const [userPermissions, setUserPermissions] = useState([])
  const [isAdmin, setIsAdmin] = useState(true)
  const [filterPaymentDelay, setFilterPaymentDelay] = useState(null)

  function onChangeLoggedUser(user) {
    if (!user) {
      api.auth.removeAuthorizationToken()
      
      const refirectRoute = window.location.origin + '/login'
      window.location.href = refirectRoute

      setTimeout(() => {
        setLoggedUser(null)
      }, 2000)

      return
    }
    loadBadges() 
    setLoggedUser(user)
  }

  async function loadBadges() {
    try {
     
    } catch (error) {
      console.error(error)      
    }
  }
  
  return (
    <GeneralContext.Provider
      value={
        {
          loggedUser,
          setLoggedUser: onChangeLoggedUser,
          userPermissions,
          setUserPermissions,
          isAdmin,
          setIsAdmin,
          show_loading, setShowLoading,
          windowWidth, windowHeight,
          mobile_mode,
          loadBadges,
          filterPaymentDelay
        }
      }
    >
      {children}
    </GeneralContext.Provider>
  );
}
